<script setup lang="ts">
import type { BecomeAuthorData } from '~/utils/crystallize/become-author'

defineProps<{
  data: NonNullable<BecomeAuthorData['components']>['editors']
}>()
</script>

<template>
  <section v-if="data" class="py-10 lg:py-28">
    <ContentGrid>
      <div class="full-width-content grid grid-cols-subgrid bg-blurple-100 rounded-2xl p-m sm:p-l md:p-xl lg:p-3xl">
        <div class="col-span-full lg:col-span-8 2xl:col-start-2 flex flex-col gap-l lg:gap-2xl">
          <hgroup class="flex flex-col gap-5">
            <h2 v-if="data.title" class="title-l" v-text="data.title" />

            <CrystallizeRichText v-for="(block, i) in data.description" :key="i" class="text-lg" :block="block" />
          </hgroup>

          <ul v-if="data.persons?.length" class="grid md:grid-cols-2 gap-y-7 md:gap-y-14 gap-x-3xl 2xl:gap-x-5xl">
            <NettbutikkArticleAuthor
              is="li"
              v-for="({ person }, i) in data.persons"
              :key="person?.name ?? i"
              v-slot="{ data: personData }"
              :data="person"
            >
              <p v-if="personData.name" class="text-lg font-bold" v-text="personData.name" />
              <div class="flex flex-col text-caption">
                <span v-if="personData.title" class="font-bold line-clamp-3" v-text="personData.title" />
                <span v-if="personData.contactInfo.phoneNumber">Tlf: <PhoneNumber class="no-underline text-caption" :value="personData.contactInfo.phoneNumber" /></span>
                <span v-if="personData.contactInfo.email" class="truncate">
                  E-post: <a class="no-underline text-caption" :title="personData.contactInfo.email" :href="`mailto:${personData.contactInfo.email}`" v-text="personData.contactInfo.email" />
                </span>
              </div>
            </NettbutikkArticleAuthor>
          </ul>
        </div>
      </div>
    </ContentGrid>
  </section>
</template>
